const LinkedInIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M100.28 448H7.4V148.9h92.88zm-46.44-340.8c-31.8 0-57.3-25.5-57.3-57.3S22.04 0 53.84 0s57.3 25.5 57.3 57.3-25.5 57.3-57.3 57.3zM447.9 448h-92.68V302.4c0-34.7-12.4-58.4-43.4-58.4-23.7 0-37.8 15.9-44 31.3-2.3 5.6-2.8 13.4-2.8 21.2V448h-92.68s1.2-239.8 0-264.1h92.68v37.4c12.3-19 34.3-46.1 83.4-46.1 60.8 0 106.4 39.6 106.4 124.7V448z" />
  </svg>
);

export default LinkedInIcon;
